export const VIEW_TYPE = {
    TABLE: 'TABLE',
    KANBAN: 'KANBAN'
}